import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_132_charts_of_accounts: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Charts of accounts",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "ledger_name",
            Name: "Charts of accounts",
            BindValue: "grid_stock",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate:
                    "modulev1/heads_balance_add_for_chart_of_accounts_head/<id>",
                },
                ActionType: "Edit",
                ScreenId: "133",
              },
              {
                Action: {
                  Action: "PDF",
                  Settings: "charts_of_accounts_report",
                },
                ActionType: ActionType.PDF_DOWNLOAD,
                tooltip: "Download PDF",
              },
            ],
            Form: {
              Name: "Charts of accounts",
              TableName: "ledgers",
              DisplayName: "Charts of accounts",
              View: "view_charts_of_accounts_ledgers",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Ledger",
                  IsMandatory: true,
                  BindValue: "ledger",
                  Json_Attribute: "ledger_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Main head",
                  IsMandatory: true,
                  BindValue: "sub_main_head",
                  Json_Attribute: "main_head",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Head group",
                  IsMandatory: true,
                  BindValue: "txt_head_group",
                  Json_Attribute: "head_group",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Head name",
                  IsMandatory: true,
                  BindValue: "ledger_group",
                  Json_Attribute: "group_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Opening balance",
                  IsMandatory: true,
                  BindValue: "txt_opening_balance",
                  Json_Attribute: "opening_balance",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Total amount",
                  IsMandatory: true,
                  BindValue: "current_balance",
                  Json_Attribute: "current_balance",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Financial year",
                  IsMandatory: true,
                  BindValue: "accounting_years",
                  Json_Attribute: "name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
